import React from 'react';
import styles from '../ProjectPhasesBar.module.scss';
import ProgressEditor from './ProgressEditor.jsx';

import {
  project_phase_form_deliverable_path,
} from '~/routes';

const DeliverableCardContent = ({project_id, deliverable, outgoingTransition, editable = false, updateDeliverableProgress = () => {}}) => {
  const {title, type, programme_form_link_id, attachments = {}} = deliverable;
  const iconClass =
    `fa-solid fa-${{activity: 'bolt-lightning', indicator: 'list-check', form_deliverable: 'file-lines', document_deliverable: 'file'}[type] || 'tachometer-alt'}`;

  const link =
    (type === 'form_deliverable' && programme_form_link_id && outgoingTransition.link)
      ? project_phase_form_deliverable_path({project_id, deliverable_id: deliverable.id})
      : (type === 'document_deliverable')
        ? (attachments.sharepoint_link || attachments.attachment_link || null)
        : null;

  return (
    <>
      <div className={styles.Title}>
        {link ? <a href={link} target="_blank" rel="noopener noreferrer">{title}</a> : title}
      </div>

      <div className={styles.InfoRow}>
        <div className={styles.Icon}>
          <i className={`${iconClass} ${styles[`${type}-type-icon`]}`}></i>
        </div>
        <ProgressEditor {...{project_id, deliverable, updateDeliverableProgress, editable}}/>
      </div>
    </>
  );
}

export default DeliverableCardContent;
